import { useFetcher } from 'react-router-dom';
import { Button, FormField, Input, Textarea } from '@dma/ui';
import type { SubmitContactMessageResultDto } from '../application/dto/SubmitContactMessageResultDto';
import './ContactForm.css';

interface ActionSuccess {
  ok: true;
  result: SubmitContactMessageResultDto;
}
interface ActionFailure {
  ok: false;
  message: string;
}
type ContactActionData = ActionSuccess | ActionFailure;

/**
 * Submits via the route's `action` (see app/routes.tsx), using `useFetcher`
 * for a non-navigating submission. This gives the four required states
 * without any additional data-fetching library:
 *   - Empty/idle: initial render, fetcher.data is undefined
 *   - Loading: fetcher.state === 'submitting'
 *   - Error: fetcher.data.ok === false
 *   - Success: fetcher.data.ok === true
 */
export function ContactForm() {
  const fetcher = useFetcher<ContactActionData>();
  const isSubmitting = fetcher.state === 'submitting' || fetcher.state === 'loading';
  const data = fetcher.data;

  if (data?.ok) {
    return (
      <div className="dma-contact-form__success" role="status">
        <p>پیام شما با موفقیت ارسال شد. به‌زودی با شما تماس گرفته خواهد شد.</p>
      </div>
    );
  }

  return (
    <fetcher.Form method="post" className="dma-contact-form" noValidate>
      {data && !data.ok ? (
        <p className="dma-contact-form__error" role="alert">
          {data.message}
        </p>
      ) : null}

      <FormField label="نام و نام خانوادگی" htmlFor="name" required>
        <Input id="name" name="name" required minLength={2} maxLength={100} disabled={isSubmitting} />
      </FormField>

      <FormField label="ایمیل" htmlFor="email" required>
        <Input id="email" name="email" type="email" required disabled={isSubmitting} />
      </FormField>

      <FormField label="تلفن (اختیاری)" htmlFor="phone">
        <Input id="phone" name="phone" type="tel" disabled={isSubmitting} />
      </FormField>

      <FormField label="موضوع" htmlFor="subject" required>
        <Input id="subject" name="subject" required minLength={5} maxLength={150} disabled={isSubmitting} />
      </FormField>

      <FormField label="پیام" htmlFor="message" required>
        <Textarea id="message" name="message" required minLength={10} maxLength={2000} rows={6} disabled={isSubmitting} />
      </FormField>

      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? 'در حال ارسال...' : 'ارسال پیام'}
      </Button>
    </fetcher.Form>
  );
}
